{
  "messages": {
    "noFiles": "Er zijn nog geen bestanden beschikbaar"
  },
  "types": {
    "UnsignedQuote": "Ongetekende offerte",
    "UnsignedFrameworkAgreement": "Ongetekende raamovereenkomst",
    "SignedQuote": "Getekende offerte",
    "SignedFrameworkAgreement": "Getekende raamovereenkomst",
    "FirstPledgeGroupAssets": "1e pandrecht activa op groepsniveau",
    "FirstPledgeClientAssets": "1e pandrecht activa op klantniveau",
    "PersonalGuarantee": "Privé borgstelling",
    "ThirdPartyPersonalGuarantee": "Privé borgstelling derden",
    "BusinessGuarantee": "Borgstelling zakelijk",
    "ThirdPartyBusinessGuarantee": "Borgstelling zakelijk derden",
    "MortgageDeclaration": "Positieve/negatieve hypotheekverklaring",
    "FirstMortgageRight": "1e recht van hypotheek",
    "SecondMortgageRight": "2e recht van hypotheek",
    "SepaContract": "SEPA contract",
    "ProofOfSigningFrameworkAgreementAndQuote": "Bewijs van ondertekening raamovereenkomst en offerte",
    "RedeemConfirmation": "Bevestiging aflossing kredietleverancier",
    "CurrentDebt": "Actieve stand van vorige krediet- of hypotheekleverancier"
  },
  "uploadedOn": "Geüpload op {date}"
}